var giphy_viewer_default = {
  "giphyWrapper": "iwFcc",
  "giphy_player": "i-vN4",
  "playIcon": "hd-Kg",
  "gifRatio": "_33gw5"
};
export {
  giphy_viewer_default as default
};
//# sourceMappingURL=giphy-viewer-scss.js.map
